/** The bays a container's footprint covers: its own for a 20, both odd bays of the pair for a 40 */
export function baysCoveredBy(c, block) {
    if (Number(c.bay) % 2 === 1)
        return [c.bay];
    const oddBays = block.getEnclosedBays().filter((b) => Number(b) % 2 === 1);
    return oddBays.length > 0 ? oddBays : [c.bay];
}
/**
 * The containers seen from above (`"highest"`) or from below (`"lowest"`) in one
 * stack of a block, per 20' footprint.
 *
 * A paired block holds two 20' bays side by side, so a row of it is two stacks
 * that need not be equally tall. Taking only the top tier of the row dropped
 * the 20 of the shorter bay (e.g. 005 topped at 22 next to 007 topped at 24).
 * Here every odd bay gets the outermost container over it, and a 40 counts for
 * both. A 40 with only one bay taken by a 20 further out still shows its other
 * half, so it is kept.
 */
export function topContainersOfStack(block, gridContent, stackKey, allTiersKeys, from) {
    var _a, _b, _c;
    const tiersInStack = allTiersKeys
        .filter((tier) => { var _a; return (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[tier]; })
        .sort((a, b) => (from === "highest" ? Number(b) - Number(a) : Number(a) - Number(b)));
    const found = [];
    const takenBays = new Set();
    const oddBays = block.getEnclosedBays().filter((b) => Number(b) % 2 === 1);
    for (const tier of tiersInStack) {
        const containers = ((_c = (_b = (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[tier]) === null || _b === void 0 ? void 0 : _b.containers) !== null && _c !== void 0 ? _c : []);
        containers.forEach((c) => {
            const bays = baysCoveredBy(c, block);
            if (bays.some((bay) => !takenBays.has(bay))) {
                found.push(c);
                bays.forEach((bay) => takenBays.add(bay));
            }
        });
        // Every bay of the block has its outermost container
        if (oddBays.length > 0 && oddBays.every((bay) => takenBays.has(bay)))
            break;
    }
    return found;
}
